import { render } from "./TelaProdutos.vue?vue&type=template&id=ce941916&scoped=true"
import script from "./TelaProdutos.vue?vue&type=script&lang=js"
export * from "./TelaProdutos.vue?vue&type=script&lang=js"

import "./TelaProdutos.vue?vue&type=style&index=0&id=ce941916&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src130918171/src/app-heineken/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce941916"]])

export default __exports__